module.exports = __webpack_public_path__ + "static/media/salmantina.38f51b00.png";